import { apiPath } from '../../constants';
import { axios, apiRequestOptions, errorRequestHandler, transformHttpResponse } from 'utils';
import download from 'downloadjs';

export const SCHEDULE_PDF_REQUEST = 'SCHEDULE_PDF_REQUEST';
export const SCHEDULE_PDF_SUCCESS = 'SCHEDULE_PDF_SUCCESS';
export const SCHEDULE_PDF_FAILURE = 'SCHEDULE_PDF_FAILURE';

export const downloadSchedulePdf = (competitionId) => {
  return function (dispatch) {
    dispatch({ type: SCHEDULE_PDF_REQUEST });
    return axios(apiRequestOptions(apiPath.SCHEDULE.PDF, null, { params: { id: competitionId }, isBlob: true }))
      .then(transformHttpResponse)
      .then(response => {
        const content = response.headers['content-type'];
        const disposition = response.headers['content-disposition'] || '';
        const filenameMatch = disposition.match(/filename="?([^";\s]+)"?/);
        const filename = filenameMatch ? filenameMatch[1] : `schedule_${competitionId}.pdf`;
        download(response.data, filename, content);
        dispatch({ type: SCHEDULE_PDF_SUCCESS });
      })
      .catch(error => transformHttpResponse(error.response))
      .catch(error => {
        dispatch({ type: SCHEDULE_PDF_FAILURE, error });
        dispatch(errorRequestHandler(error));
      });
  };
};
